import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { modal } from "../../../../util";
import {
  ToggleButton,
  ToggleButtonGroup
} from "@material-ui/lab";


const defaultFormValues = {
  localizations: {
    en: {
      name: "",
      description: null
    },
    tc: {
      name: "",
      description: null
    }
  },
  status: "true",
  updateTime: dayjs().format("YYYY-MM-DDTHH:mm:ss[Z]"),
};

const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  leftGrid: {
    maxHeight: 100,
  },
  last: {
    margin: 0,
  },
  topBar: {
    padding: 0,
  },
  pagination: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  "&::placeholder": {
    color: "grey",
  },
  statusBtn: {
    width: "100%",
    backgroundColor: "white",
    height: "50px",
    marginBottom: "20px",
  },
}));

export default function ProgrammeCategoryForm({ disabled, ...props }) {
  const { history, fetchData } = props;
  const classes = useStylesAll();
  let { id } = useParams();
  const [defaultValues, setDefaultValues] = useState(defaultFormValues);

  const { control, handleSubmit, setValue, getValues } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const formatRowToData = (row) => {
    row.updateTime = dayjs().format("YYYY-MM-DDTHH:mm:ss[Z]")
    return row;
  }

  useEffect(() => {
    if (id) {
      apiHelper.hkiff
        .getProgrammeCategoryById(id)
        .then((response) => {
          console.log(response.data);
          setDefaultValues(response.data);
          setValue("localizations", response.data.localizations);
          setValue("status", response.data.status);
        })
        .catch(function (error) {
          console.log(error);
        });
    }else {
      setValue("status", true);
    }
  }, []);

  const updateProgrammeCategory = async (data) => {
    try {
      console.log(formatRowToData(data));
      const result = await apiHelper.hkiff.updateProgrammeCategoryById(
        id, formatRowToData(data)
      );
      console.log(result.data);
      toast.dark("Your changes is saved.");
    } catch (err) {
      console.log(err);
    }
  };

  const createProgrammeCategory = async (data) => {
    try {
      const result = await apiHelper.hkiff.postProgrammeCategory(
        formatRowToData(data)
      );
      if (result.data.id) {
        toast.dark("Category created.");
        history.push("/hkiff/programme/programme-category");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    console.log(data);
    const sendProgrammeCategory = () => {
      if (id) {
        updateProgrammeCategory(data);
      } else {
        createProgrammeCategory(data);
      }
    };
    sendProgrammeCategory();
  };

  const deleteProgrammeCategory = React.useCallback(async (id) => {
    const decision = await modal.fire({
      title: "Delete Category",
      text: "Are you sure to delete this category?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        const result = await apiHelper.hkiff.deleteProgrammeCategoryById(id);
        if (result.data.code === 0) {
          history.push(`/hkiff/programme/programme-category`);
          toast.dark("Category deleted.");
        }
      } catch (err) {
        console.log(err);
      }
    }
  }, []);

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{props.description}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box width="100%">

            <Controller
              control={control}
              name="localizations.en.name"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (English)"
                    variant="outlined"
                    {...field}
                    fullWidth
                    helperText="The name is how it appears on your site."
                  />
                );
              }}
            />

            <Controller
              control={control}
              name="localizations.tc.name"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (Traditional Chinese)"
                    variant="outlined"
                    {...field}
                    fullWidth
                    helperText="The name is how it appears on your site."
                  />
                );
              }}
            />

            <Controller
              control={control}
              name="localizations.en.description"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Description"
                    variant="outlined"
                    multiline
                    rows={4}
                    {...field}
                    fullWidth
                  />
                );
              }}
            />

            <Controller
              control={control}
              name="localizations.tc.description"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Description (Traditional Chinese)"
                    variant="outlined"
                    multiline
                    rows={4}
                    {...field}
                    fullWidth
                  />
                );
              }}
            />

            <Controller
              control={control}
              name="status"
              render={({
                field: {
                  value,
                  onChange,
                  ...rest
                },
                fieldState: { error },
              }) => (
                <ToggleButtonGroup
                  {...rest}
                  value={value}
                  onChange={(event, newFormats) => {
                    onChange(newFormats);
                  }}
                  exclusive
                  aria-label="Status"
                  className={classes.statusBtn}
                >
                  <ToggleButton
                    value={true}
                    aria-label="Active"
                    style={{ width: "50%" }}
                    disabled={disabled}
                  >
                    Active
                                        </ToggleButton>
                  <ToggleButton
                    value={false}
                    aria-label="Inactive"
                    style={{ width: "50%" }}
                    disabled={disabled}
                  >
                    Inactive
                                        </ToggleButton>
                </ToggleButtonGroup>
              )}
            />

            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              {disabled || (
                <Box>
                  <Button
                    className={classes.last}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                  >
                    {props.submitBtnTxt}
                  </Button>
                  {(id != "new" && id) && (
                    <Button
                      variant="text"
                      disableElevation
                      style={{
                        color: "#962013",
                        padding: "9px 16px",
                      }}
                      onClick={() => {
                        deleteProgrammeCategory(id);
                      }}
                    >
                      Delete Category
                    </Button>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
}
